import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import Status from "components/presentation/Status";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getDateTimeFormat } from "helpers/utils";

export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let competitorPlace = competitor?.cp_code ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} /> : ''
    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div className=''>
                {competitor
                    ? competitor?.cp_code
                    : competitorPlace
                        ? competitorPlace
                        : <></>
                }
            </div>
        </div>
    )
}

export function CompetitorBlock(props) {
    let bolding = props?.cp_wlt === 'W' ? ' fw-bold' : '';
    if (props?.boldWinner === false) {
        bolding = '';
    }
    return (
        <div className={'score-competitor-container  d-flex flex-row justify-content-start' + bolding}>
            {/*<div className='score-uniform score-uniform-home'></div>*/}

            <div className='score-noc'>
                <Noc className='me-1' {...props?.participant?.organisation} />
            </div>
            <div className='score-name'><Competitor  {...props?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={props.screen} /> </div>
        </div>
    )
}

export function Footer({ data }) {

    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            {isLessLiveStatus(data?.result?.status?.code) && <div className='row w-100'><div className='text-start col'>{dateComponent}</div></div>}
        </>
    )
}